import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ComponentFormData } from '../jurisdiction.domain';
import { PowerFacilityData, PowerMeterData } from '../facilities-form/facilities-form.domain';

@Injectable({
  providedIn: 'root',
})
export class SiteElectricityInstallationTechnicalDataService {
  private triggerComponentFormUpdate$: Subject<ComponentFormData>;

  constructor() {
    this.triggerComponentFormUpdate$ = new Subject<ComponentFormData>();
  }

  get registerForComponentFormUpdate(): Subject<ComponentFormData> {
    return this.triggerComponentFormUpdate$;
  }

  preparePowerMeterData(data: any): PowerMeterData {
    return {
      sk_power_meter_type: data.meterType,
      sk_modern_meter_subtype: data.modernMeterSubtype,
      sk_estimated_annual_consumption: data.annualConsumption,
      sk_meter_mount: data.selectMount,
      transducer_converterfactor: data.transformerFactor,
      transducer_customerprovided: data.providedByCustomerCheckbox ? '1' : '0',
      rlm_measurement: data.rlmMeasurement ? '1' : '0',
    };
  }

  prepareFacilityBaseData(data: any): PowerFacilityData {
    return {
      sk_power_facility_type: data.facilityType,
      sk_internal_power_sitecon: data.internalPowerSiteCon,
      sk_external_power_sitecon: data.externalPowerSiteCon,
      sk_sitecon_power_subtype: data.siteConPowerSubtype,
      crane_in_place: data.craneInPlaceCheckbox ? true : false,
    };
  }
}
